import React from "react";
import { Box, Grid, Typography } from "@material-ui/core";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { IProduct } from "../../services/dashboard.services";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    subItemBox: {
      paddingBottom: "20px",
    },
    productText: {
      color: theme.palette.dark.main,
      fontWeight: "bold",
      fontSize: "0.9rem",
      height: "20px",
    },
    subTextGrid: {
      color: theme.palette.dark.main,
      width: "45px",
    },
    itemText: {
      color: theme.palette.dark.main,
      fontSize: "0.85rem",
      height: "20px",
      marginTop: "8px",
    },
    quantityBox: {
      display: "flex",
      justifyContent: "center",
      fontWeight: "bold",
      fontSize: "0.9rem",
    },
    productBox: {
      display: "flex",
    },
  })
);

export default function PlanDataItemLayout(props: IProps) {
  // Component styles
  const classes = useStyles();
  const { t } = useTranslation();
  const { quantity, product } = props;
  /* Hooks */
  return (
    <Box className={classes.subItemBox}>
      <Typography className={classes.productText}>
        {product.name} {t("gateways")}
      </Typography>
      <Box className={classes.itemText}>
        <Grid container>
          <Grid className={classes.subTextGrid}>{t("quantity")}</Grid>
          <Grid className={classes.quantityBox}>{quantity}</Grid>
        </Grid>
      </Box>
    </Box>
  );
}

interface IProps {
  id: string;
  quantity: number;
  productID: string;
  product: IProduct;
}
